import { useDarkMode as useDarkModeProvider } from 'providers/DarkModeProvider';

export const useDarkMode = useDarkModeProvider;